/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import CreateModal from 'components/custom/modal/CreateModal';
import InputBox from 'components/custom/forms/InputBox';
import { useFormik } from 'formik';
import useModalManage from 'hooks/custom/useModalManage';
import * as Yup from 'yup';
import { Col, Row } from 'react-bootstrap';
import LabelInput from 'components/custom/forms/LabelInput';
import LabelSelector from 'components/custom/forms/LabelSelector';
import postData from 'services/postData';
import { useAlert } from 'providers/AlertModalProvider';
import apiEndpoints from 'constants/apiEndpoints';
import useManageLocation from 'hooks/custom/useManageLocation';
import { useEffect, useState } from 'react';
import Button from 'components/base/Button';
import Icon from 'components/icon';

const NewBranchBtn = ({
  searchText,
  setFunction = () => {},
  handleRefresh = () => {}
}) => {
  const [isBranchOpen, setBranchOpen] = useState(false);

  return (
    <>
      <Button
        className="text-decoration-none px-3 w-100 text-start"
        onClick={() => setBranchOpen(true)}
        variant="link"
      >
        <Icon
          icon={'flowbite:circle-plus-solid'}
          className="me-1"
          fontSize={'16px'}
        />
        Add {searchText ? `"${searchText}"` : 'New Branch'}
      </Button>

      {isBranchOpen && (
        <CreateBranch
          show={isBranchOpen}
          handleClose={() => setBranchOpen(false)}
          onComplete={() => setBranchOpen(false)}
          callback={data => setFunction(data)}
          handleRefresh={handleRefresh}
          defaultName={searchText}
        />
      )}
    </>
  );
};

const CreateBranch = ({
  show,
  handleClose,
  handleRefresh,
  callback = () => {},
  defaultName = ''
}) => {
  const [modalLoading, modalMessage, setModalLoading] = useModalManage();
  const { country, state, city, manageLocation, getDefaultLocation } =
    useManageLocation(false);
  const { showAlert } = useAlert();

  const handleCreateBranch = async values => {
    setModalLoading(true, 'Creating branch');
    const request = await postData(values, apiEndpoints.branch.create);
    if (request.status) {
      setModalLoading(false);
      showAlert({
        variant: 'info',
        message: `Approval has been successfully raised to create the branch ${values.branch_name}.`
      });
      handleRefresh();
      callback({ data: request.data, name: values.branch_name });
      handleClose();
    } else {
      setModalLoading(false);
      showAlert({
        variant: 'danger',
        message: `Failed to create the branch ${values.branch_name}.`
      });
    }
  };

  const formik = useFormik({
    initialValues: {
      branch_name: defaultName,
      country_id: '',
      state_id: '',
      city_id: '',
      country_name: '',
      state_name: '',
      city_name: '',
      latitude: '',
      longitude: ''
    },
    validationSchema: Yup.object({
      branch_name: Yup.string()
        .required('Please provide the Branch name')
        .max(50, 'Branch name cannot be longer than 50 characters'),
      country_id: Yup.string().required('Please provide the Country name'),
      state_id: Yup.string().required('Please provide the State name'),
      city_id: Yup.string().required('Please provide the City name'),
      country_name: Yup.string(),
      state_name: Yup.string(),
      city_name: Yup.string(),
      latitude: Yup.number()
        .typeError('The Latitude must be a decimal number')
        .test('is-decimal', 'The latitude must be a decimal number', value => {
          return value && value % 1 !== 0;
        })
        .required('Please enter latitude'),

      longitude: Yup.number()
        .typeError('The Longitude must be a decimal number')
        .test('is-decimal', 'The longitude must be a decimal number', value => {
          return value && value % 1 !== 0;
        })
        .required('Please enter longitude')
    }),

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onSubmit: values => {
      handleCreateBranch(values);
    }
  });

  const handleLocationChange = (name, value) => {
    manageLocation(formik, name, value);
  };

  useEffect(() => {
    getDefaultLocation({ country_id: 101 });
    formik.setFieldValue('country_id', 101);
    formik.setFieldValue('country_name', 'India');
  }, []);

  return (
    <CreateModal
      show={show}
      loading={modalLoading}
      loadingText={modalMessage}
      handleClose={handleClose}
      heading={'Create Branch'}
      handleSubmit={formik.handleSubmit}
    >
      <Row className="gy-2 gx-2">
        <Col xs={12} sm={12}>
          <InputBox>
            <LabelInput
              label={'Branch Name'}
              controlId={'branch_name'}
              formik={formik}
              errorProps={{ tooltip: false }}
              required
            />
          </InputBox>
        </Col>
        <Col xs={12} sm={6}>
          <InputBox>
            <LabelSelector
              required
              options={{
                data: country,
                valueKey: 'country_id',
                labelKey: 'country_name'
              }}
              onChange={handleLocationChange}
              inputProps={{ disabled: country.length < 1 }}
              label={'Country'}
              controlId={'country_id'}
              controlLabelId={'country_name'}
              formik={formik}
              errorProps={{ tooltip: false }}
              placeholder={'Select Country'}
            />
          </InputBox>
        </Col>
        <Col xs={12} sm={6}>
          <InputBox>
            <LabelSelector
              required
              options={{
                data: state,
                valueKey: 'state_id',
                labelKey: 'state_name'
              }}
              onChange={handleLocationChange}
              inputProps={{ disabled: state.length < 1 }}
              label={'State'}
              controlId={'state_id'}
              controlLabelId={'state_name'}
              formik={formik}
              errorProps={{ tooltip: false }}
              placeholder={'Select State'}
            />
          </InputBox>
        </Col>
        <Col xs={12} sm={6}>
          <InputBox>
            <LabelSelector
              required
              options={{
                data: city,
                valueKey: 'city_id',
                labelKey: 'city_name'
              }}
              onChange={handleLocationChange}
              inputProps={{ disabled: city.length < 1 }}
              label={'City'}
              controlId={'city_id'}
              controlLabelId={'city_name'}
              formik={formik}
              errorProps={{ tooltip: false }}
              placeholder={'Select City'}
            />
          </InputBox>
        </Col>
        <Col xs={12} sm={3}>
          <InputBox>
            <LabelInput
              required
              errorProps={{ tooltip: false }}
              label={'Latitude'}
              controlId={'latitude'}
              formik={formik}
              information={'The Latitude must be a decimal number'}
            />
          </InputBox>
        </Col>
        <Col xs={12} sm={3}>
          <InputBox>
            <LabelInput
              required
              errorProps={{ tooltip: false }}
              label={'Longitude'}
              controlId={'longitude'}
              formik={formik}
              information={'The Longitude must be a decimal number'}
            />
          </InputBox>
        </Col>
      </Row>
    </CreateModal>
  );
};

export default CreateBranch;
export { NewBranchBtn };
